
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';

interface AddDomainFormProps {
  newDomain: string;
  setNewDomain: (value: string) => void;
  addDomain: () => Promise<void>;
  isLoading: boolean;
}

export const AddDomainForm: React.FC<AddDomainFormProps> = ({
  newDomain,
  setNewDomain,
  addDomain,
  isLoading,
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="new-domain">Ajouter un domaine</Label>
      <div className="flex gap-2">
        <Input
          id="new-domain"
          placeholder="mondomaine.com"
          value={newDomain}
          onChange={(e) => setNewDomain(e.target.value)}
          disabled={isLoading}
        />
        <Button onClick={addDomain} disabled={isLoading}>
          {isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            "Ajouter"
          )}
        </Button>
      </div>
    </div>
  );
};

export default AddDomainForm;
